<template>
  <div>
    <stepTitle :navItems="['Travel Taiwan']" :index="1" :step="1"/>
    <div class="container my-4 px-0 py-5" style="background:#fff; min-height:80vh">
      <router-view :key="$route.path"></router-view>
    </div>
  </div>
</template>

<script>
// import labelTag from './record/Label'
import stepTitle from '../../Teacher/StepTitle'
export default {
  name: 'TWLayout',

  data () {
    return {
    }
  },
  computed: {
    noTag () {
      return this.$route.name === 'TWIndex' ? 0 : 1
    }
  },
  mounted () {
    // console.log(this.noTag)
  },
  methods: {
  },
  components: {
    stepTitle
    // labelTag
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/color.scss";
.tag {
    text-align: left;
    border-bottom: #bbbbbb solid 2px;
    .tag-boxes {
      margin-left: 60px;
      position: relative;
    }
  }
  .tag-body {
    white-space:nowrap;
		cursor: pointer;
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px 10px 0 0;
    border-top: 2px #c7c7c7 solid;
    border-right: 2px #c7c7c7 solid;
    border-left: 2px #c7c7c7 solid;
    color: #000000;
		&:hover {
      background-color: #c7c7c7;
    }
	}
  .active {
    border-radius: 10px 10px 0 0;
    background-color: #c7c7c7;
  }
  @media only screen and (max-width: 768px) {
    .type-selecter {
      position: absolute;
      left: 20px;
    }
  }
</style>


// WEBPACK FOOTER //
// TWLayout.vue?12ce9f85